import React, { useState, useEffect, useRef } from "react";
import LeaseApiService from "../../../services/apiService";
import { RiRefreshLine } from "react-icons/ri";
import Transection from "../transection";
import { ClipLoader } from "react-spinners";
import { getName } from "../../../../Redux/selecters";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { FaSave, FaChevronLeft, FaEdit, FaTrash } from "react-icons/fa";
import UnitDetailsEdt from "../editLease/unitDetails";
import moment from "moment";

const LeaseAgreementRenew = () => {
    const apiService = new LeaseApiService();
    const userName = useSelector(getName);
    const [loading, setloader] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [selectedUnitIndex, setSelectedUnitIndex] = useState(null);
    const [loader, setLoader] = useState(true);

    const [periodFrom, setPeriodFrom] = useState("");
    const [periodTo, setPeriodTo] = useState("");
    const [leaseTerm, setLeaseTerm] = useState("");
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const [dataList, setDataList] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [propertylist, setPropertyList] = useState([]);
    const [taxCodeList, setTaxCodeList] = useState([]);
    const [customerList, setCUstomerList] = useState([]);
    const [leasingAgent, setLeasingAgent] = useState([]);
    const [remarksList, setRemarksList] = useState([]);
    const [additionalCharges, setAdditionalCharges] = useState([]);
    const [unitData, setUntData] = useState();
    const [editingRow, setEditingRow] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const gridRef = useRef();
    const location = useLocation();
    const leaseData = location.state;
    const navigate = useNavigate();
    const totalRent = dataList?.reduce((sum, row) => sum + (parseFloat(row?.rentForPeriod) || 0), 0);
    const totalVat = dataList?.reduce((sum, row) => sum + (parseFloat(row?.vat) || 0), 0);
    const rentPerAnum = dataList?.reduce((sum, row) => sum + (parseFloat(row?.rentPerAnum) || 0), 0);
    const totalDiscount = dataList?.reduce((sum, row) => sum + (parseFloat(row?.FreeRent) || 0), 0);
    const calculatedTotal = dataList?.reduce((sum, row) => sum + (parseFloat(row?.total) || 0), 0);
    useEffect(() => {
        getUserList();
    }, [leaseData]);

    const calculateDaysDifference = (from, to) => {
        const fromDate = new Date(from);
        const toDate = new Date(to);
        const diffTime = toDate - fromDate;
        let totalDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return (totalDays + 1)
    };

    const getUserList = async () => {
        try {
            setLoader(true)
            const params = new URLSearchParams();
            params.append("dropdownTypes", "LASerPropertyName,LACustomerName,LALeasingAgent,LALeaseRemarks,VatPercentage");
            const customerRes = await apiService.getApiParamater("GET_PROPERT_DROP", `?${params?.toString()}`);
            setCUstomerList(customerRes?.data?.dropdowns?.LACustomerName);
            setPropertyList(customerRes?.data?.dropdowns?.LASerPropertyName);
            setLeasingAgent(customerRes?.data?.dropdowns?.LALeasingAgent);
            setRemarksList(customerRes?.data?.dropdowns?.LALeaseRemarks);
            setTaxCodeList(customerRes?.data?.dropdowns?.VatPercentage);
            if (leaseData) {

                const leaseDataParam = new URLSearchParams();
                leaseDataParam.append("Action", "getLeaseDetailsById");
                leaseDataParam.append("GroupId", leaseData?.groupId);
                const leaseDataRes = await apiService.getApiParamater("GET_UNITNO_DATA", `?${leaseDataParam?.toString()}`);
                let leaseResData = ""
                if (leaseDataRes?.data?.result?.data?.length > 0) {
                    let leaseResponse = leaseDataRes?.data?.result?.data[0]
                    leaseResData = leaseResponse;
                } else {
                    let leaseResponse = leaseDataRes?.data?.result?.data
                    leaseResData = leaseResponse;
                }
                const additionalChargesParam = new URLSearchParams();
                additionalChargesParam.append("Action", "getLeaseAdditionalDetailsById");
                additionalChargesParam.append("GroupId", leaseData?.groupId);
                const additionalChargesRes = await apiService.getApiParamater("GET_UNITNO_DATA", `?${additionalChargesParam?.toString()}`);
                let AdditionalChargesData = additionalChargesRes?.data?.result?.data
                setAdditionalCharges(AdditionalChargesData)
                if (AdditionalChargesData?.length === 0) {
                    const additionalParam = new URLSearchParams();
                    additionalParam.append("Action", "GetChargesDetails");
                    additionalParam.append("RentPerAnnum", leaseResData?.Rent_Per_Annum);
                    const Additionalres = await apiService.getApiParamater(
                        "GET_UNITNO_DATA",
                        `?${additionalParam?.toString()}`
                    );
                    debugger
                    let additional = Additionalres?.data?.result?.data
                    if (additional?.length > 0) {
                        const updatedData = additional.map(item => ({
                            ...item,
                            isSelected: true
                        }));
                        setAdditionalCharges(updatedData);
                    } else if (additional?.Description) {
                        const singleItem = {
                            ...additional,
                            isSelected: true
                        };
                        setAdditionalCharges([singleItem]);
                    }
                }
                // broker = agent
                const selectedAgent = customerRes?.data?.dropdowns?.LALeasingAgent?.find(pro => pro?.value === leaseResData?.Agent);
                // Leasing Agent = salesperson
                const SalesPerson = customerRes?.data?.dropdowns?.LALeasingAgent?.find(pro => pro?.value === leaseResData?.SalesPerson);
                const Cust1 = customerRes?.data?.dropdowns?.LACustomerName?.find(pro => pro?.value === leaseResData?.Cust1_No);
                const Cust2 = customerRes?.data?.dropdowns?.LACustomerName?.find(pro => pro?.value === leaseResData?.Cust2_No);
                const remarks = customerRes?.data?.dropdowns?.LALeaseRemarks?.find(pro => pro?.text === leaseResData?.Remarks);
                const taxCode = customerRes?.data?.dropdowns?.VatPercentage?.find(pro => parseInt(pro?.value) === leaseResData?.Tax_Code);
                // Cust no 1
                const cust1params = new URLSearchParams();
                cust1params.append('Action', 'GetCustomerDetailsByTenantNo');
                cust1params.append('TenantNo', leaseResData?.Cust1_No);
                const cust1res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${cust1params.toString()}`);
                // Cust no 2
                const params = new URLSearchParams();
                params.append('Action', 'GetCustomerDetailsByTenantNo');
                params.append('TenantNo', leaseResData?.Cust2_No);
                const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
                const today = new Date();
                const formattedToday = today.toISOString().split("T")[0];
                debugger
                const leaseExpiry = leaseResData?.Lease_Expiry;
                const leaseTerm = parseInt(leaseResData?.LeaseTerm); // in days

                if (leaseExpiry && leaseTerm) {
                    const nextPeriodFrom = moment(leaseExpiry).add(1, 'days'); // next day
                    const nextPeriodTo = moment(nextPeriodFrom).add(leaseTerm - 1, 'days'); // lease term days

                    setPeriodFrom(nextPeriodFrom.format('YYYY-MM-DD'));
                    setPeriodTo(nextPeriodTo.format('YYYY-MM-DD'));
                    setLeaseTerm(leaseTerm);
                }
                setTransData({
                    ...transData,
                    transectionDate: formattedToday,
                    periodFrom: leaseResData?.Lease_Date,
                    periodTo: leaseResData?.Lease_Expiry,
                    noInstallment: leaseResData?.PaymentTermNoOfChqs,
                    leaseAgent: { label: SalesPerson?.value || "", value: SalesPerson?.text || "" },
                    Broker: { label: selectedAgent?.value || "", value: selectedAgent?.text || "" },
                    CustomerName: { label: Cust1?.text || "", value: Cust1?.value || "" },
                    CustomerAccount: { label: Cust1?.value || "", value: cust1res?.data?.result?.data || "" },
                    JointCustomerName: { label: Cust2?.text || "", value: Cust2?.value || "" },
                    JointCustomerAccount: { label: Cust2?.value || "", value: res?.data?.result?.data || "" },
                    remarks: { label: remarks?.value || "", value: remarks?.text || "" },
                    remarks2: remarks?.text,
                    arabicRemarks: leaseResData?.RentPI_Remarks,
                    leaseTerm: leaseTerm
                });


                if (leaseDataRes?.data?.result?.data?.length > 0) {
                    const formattedEntry = leaseDataRes?.data?.result?.data?.map((item, index) => ({
                        Property: {
                            value: item.Property_Id || "", // → property_Id
                            label: item.Property_Name || "" // → propertyName
                        },
                        Unit: {
                            value: item.Unit_No || "", // → unitNo
                            label: item.Unit_No || ""
                        },
                        vatRecord: item?.Tax_Code,
                        noCommunity: "",
                        rentPerAnum: item?.Rent_Per_Annum?.toFixed(3),
                        unitClass: item?.UnitClass,
                        type: item?.Unit_Type,
                        rentForPeriod: item?.Rent?.toFixed(3),
                        unitRefNo: item?.UnitRefNo,
                        bedRooms: item?.Bedrooms,
                        totalArea: item?.Total_Area,
                        Landloard: item?.Landlord,
                        taxCode: { label: taxCode?.text, value: taxCode?.value },
                        category: item?.Unit_Category,
                        vat: item?.VAT,
                        FreeRent: item?.Discount?.toFixed(3),
                        discount: item?.Discount?.toFixed(3),
                        total: item?.Total?.toFixed(3),
                        parkingNo: item?.ParkingNo,
                        munAcNo: item?.MuncAcNo,
                        MunicipalityNo: item?.MunicipalityNo,
                        Parking: item?.Parking,
                        taxRate: item?.TaxPercent || 0,
                        discountPerc: item?.DiscountPercent || 0,
                        discount: item?.Discount?.toFixed(3) || 0,
                        vatRecord: item?.TaxCode,
                    }));
                    setDataList(formattedEntry)
                } else {
                    const formattedEntry = {
                        Property: {
                            value: leaseResData.Property_Id || "", // → property_Id
                            label: leaseResData.Property_Name || "" // → propertyName
                        },
                        Unit: {
                            value: leaseResData.Unit_No || "", // → unitNo
                            label: leaseResData.Unit_No || ""
                        },
                        vatRecord: leaseResData?.Tax_Code,
                        noCommunity: "",
                        rentPerAnum: leaseResData?.Rent_Per_Annum?.toFixed(3),
                        unitClass: leaseResData?.UnitClass,
                        type: leaseResData?.Unit_Type,
                        rentForPeriod: leaseResData?.Rent?.toFixed(3),
                        unitRefNo: leaseResData?.UnitRefNo,
                        bedRooms: leaseResData?.Bedrooms,
                        totalArea: leaseResData?.Total_Area,
                        Landloard: leaseResData?.Landlord,
                        taxCode: { label: taxCode?.text, value: taxCode?.value },
                        category: leaseResData?.Unit_Category,
                        vat: leaseResData?.VAT,
                        FreeRent: leaseResData?.Discount?.toFixed(3),
                        discount: leaseResData?.Discount?.toFixed(3),
                        total: leaseResData?.Total?.toFixed(3),
                        parkingNo: leaseResData?.ParkingNo,
                        munAcNo: leaseResData?.MuncAcNo,
                        MunicipalityNo: leaseResData?.MunicipalityNo,
                        Parking: leaseResData?.Parking,
                        taxRate: leaseResData?.TaxPercent || 0,
                        discountPerc: leaseResData?.DiscountPercent || 0,
                        discount: leaseResData?.Discount?.toFixed(3) || 0,
                        vatRecord: leaseResData?.TaxCode,
                    };
                    setDataList([formattedEntry])
                }
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error("Error fetching data:", error?.customerRes?.data?.message);
        }
    };
    const [formData, setFormData] = useState({
        vatRecord: "",
        Property: [],
        Unit: [],
        noCommunity: "",
        rentPerAnum: "",
        unitClass: "",
        type: "",
        rentForPeriod: "",
        unitRefNo: "",
        bedRooms: "",
        FreeRent: "",
        discountPerc: "",
        totalArea: "",
        Landloard: "",
        taxCode: [],
        category: "",
        vat: "",
        discount: "",
        total: "",
        parkingNo: "",
        munAcNo: "",
        Parking: "",
        taxRate: "",
    });
    const [transData, setTransData] = useState({
        transectionDate: "",
        periodFrom: "",
        periodTo: "",
        noInstallment: "",
        CustomerName: "",
        CustomerAccount: "",
        leaseAgent: "",
        JointCustomerName: "",
        JointCustomerAccount: "",
        Broker: "",
        remarks: "",
        remarks2: "",
        arabicRemarks: "",
    });
    const handleclearform = () => {
        setFormData({
            Property: [],
            Unit: [],
            noCommunity: "",
            rentPerAnum: "",
            unitClass: "",
            type: "",
            rentForPeriod: "",
            unitRefNo: "",
            bedRooms: "",
            FreeRent: "",
            discountPerc: "",
            totalArea: "",
            Landloard: "",
            taxCode: [],
            category: "",
            vat: "",
            discount: "",
            total: "",
            parkingNo: "",
            munAcNo: "",
            Parking: "",
        });
    };
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map(
            (_, index) => index === tabIndex
        );
        setGridVisibility(newGridVisibility);
    };
    const safeNumber = (val) => (typeof val === 'number' && !isNaN(val) ? val : 0);
    const handleGridChange = async (data, newValue, rowIndex, changedField) => {
        let gridData;
        let vatDescription;
        let amount;
        let discountPerc = parseFloat(data?.discountPerc) || 0;

        if (changedField === 'Amount') {
            vatDescription = data?.VATDescription;
            gridData = taxCodeList.find((temp) => vatDescription == temp?.text);
            amount = parseFloat(newValue) || 0;
        } else {
            gridData = taxCodeList.find((temp) => newValue == temp?.text);
            vatDescription = gridData?.text;
            amount = parseFloat(data?.Amount) || 0;
        }

        const discountAmount = (amount * discountPerc) / 100;
        const taxAmount = gridData ? (amount * (gridData?.value)) / 100 : 0;
        const totalAmount = amount - discountAmount + taxAmount;

        const updatedata = [...additionalCharges];
        let previousdata = updatedata[rowIndex];

        try {
            let recordId = previousdata?.vatRecord;
            if (vatDescription && (!previousdata?.vatRecord || changedField !== 'Amount')) {
                const taxParam = new URLSearchParams();
                taxParam.append("Action", "GetTaxRecordIdByTaxName");
                taxParam.append("TaxDescription", gridData?.text);

                const taxrecord = await apiService.getApiParamater(
                    "GET_UNITNO_DATA",
                    `?${taxParam?.toString()}`
                );
                recordId = taxrecord?.data?.result?.data?.RecordId;
            }

            previousdata = {
                ...previousdata,
                Amount: safeNumber(amount),
                vatRecord: recordId,
                Total: safeNumber(totalAmount),
                VAT: safeNumber(taxAmount),
                VATPercent: safeNumber(gridData?.value),
                VATDescription: vatDescription,
                CrAcName: previousdata?.CrAcName ?? "",
                Remarks: previousdata?.Remarks ?? "",

            };
            updatedata[rowIndex] = previousdata;
            setAdditionalCharges(updatedata);
        } catch (error) {
            console.error("Error fetching tax record:", error);
        }
    }
    const colDefs = [
        {
            // headerName: "CheckBox",
            width: 50,
            checkboxSelection: true,
            headerCheckboxSelection: true,
            suppressMovable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "center" },
        },
        {
            headerName: "Description",
            field: "Description",
            filter: true,
            floatingfilter: true,
            suppressMovable: true,
            width: 200,
            editable: true,
        },
        {
            headerName: "Amount",
            field: "Amount",
            suppressMovable: true,
            width: 150,
            editable: true,
            onCellValueChanged: (params) => {
                handleGridChange(params?.data, params?.newValue, params?.node?.rowIndex, 'Amount');
            },
        },
        // {
        //   headerName: "Vat Value",
        //   field: "VATPercent",
        //   filter: true,
        //   floatingfilter: true,
        //   suppressMovable: true,
        //   width: 150,
        // },
        {
            headerName: "Vat Amount",
            field: "VAT",
            filter: true,
            floatingfilter: true,
            suppressMovable: true,
            width: 150,
            // editable: true,
        },
        {
            headerName: "Vat Description",
            field: "VATDescription",
            filter: true,
            floatingfilter: true,
            suppressMovable: true,
            width: 150,
            editable: true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: taxCodeList?.map((cost) => (cost?.text)),
            },
            onCellValueChanged: (params) => {
                handleGridChange(params?.data, params?.newValue, params?.node?.rowIndex);
            }
        },
        {
            headerName: "Total",
            field: "Total",
            filter: true,
            floatingfilter: true,
            suppressMovable: true,
            width: 150,
        },
        {
            headerName: "Posting",
            field: "Posting",
            filter: true,
            floatingfilter: true,
            suppressMovable: true,
            width: 150,
            editable: true,
            cellRenderer: "agCheckboxCellRenderer",
            cellEditor: "agCheckboxCellEditor",
            cellStyle: { textAlign: "center" },
        },
        {
            headerName: "Cradit Account",
            field: "CrAcCode",
            filter: true,
            floatingfilter: true,
            suppressMovable: true,
            width: 200,
            editable: true,
        },
        {
            headerName: "Remarks",
            field: "Remarks",
            filter: true,
            editable: true,
            floatingfilter: true,
            suppressMovable: true,
            width: 200,
            // editable: true,
        },
        {
            headerName: "Deposit",
            field: "IsDeposit",
            filter: true,
            floatingfilter: true,
            suppressMovable: true,
            width: 200,
            editable: true,
            cellRenderer: "agCheckboxCellRenderer",
            cellEditor: "agCheckboxCellEditor",
            cellStyle: { textAlign: "center" },
        },
        {
            headerName: "Actions",
            width: 100,
            suppressMovable: true,
            cellClass: "actions-cell",
            cellRenderer: (params) => {
                return (
                    <div className="actions-cell">
                        <FaEdit
                            className="fa-edit"
                            style={{ cursor: "pointer" }}
                            title="Edit"
                            onClick={() => handleEdit(params?.rowIndex)}
                        />
                        <FaTrash
                            className="fa-trash"
                            style={{ cursor: "pointer", marginLeft: "10px" }}
                            title="Delete"
                            onClick={() => handleDelete(params?.rowIndex)}
                        />
                    </div>
                );
            },
        },
    ];
    const handleDelete = (rowIndex) => {
        const temp = [...additionalCharges];
        temp.splice(rowIndex, 1);
        setAdditionalCharges(temp);
    };
    const handleEdit = (rowIndex) => {
        const columnsToEdit = colDefs.map((col) => col.field);

        gridRef.current.api.startEditingCell({
            rowIndex,
            colKey: columnsToEdit[1],
        });
    };
    const handleSave = async () => {
        try {
            setloader(true);
            if (!transData?.noInstallment) {
                toast.warning(`Please Enter No of Installment`);
                setloader(false);
                return;
            } else if (!transData?.remarks2) {
                toast.warning(`Please Select Remarks`);
                setloader(false);
                return;
            } else if (!transData?.CustomerAccount?.label) {
                toast.warning(`Please Select Primary Tenant`);
                setloader(false);
                return;
            } else if (!transData?.leaseAgent?.label) {
                toast.warning(`Please Select Lease Agent`);
                setloader(false);
                return;
            }
            // const periodYear = new Date(transData?.periodFrom).getFullYear();
            // const leaseYear = new Date(leaseData?.leaseStart).getFullYear();
            // if (periodYear !== leaseYear) {
            //     toast.warning(`Lease start year cannot be changed.`);
            //     setloader(false);
            //     return;
            // }

            const currentDatetimeUTC = new Date().toISOString();
            const unitDetailsList = await Promise.all(
                dataList.map(async (item) => {
                    const validation = new URLSearchParams();
                    validation.append("Action", "CheckAgreementValidPeriod");
                    validation.append("PeriodFrom", transData?.periodFrom);
                    validation.append("PeriodTo", transData?.periodTo);
                    // validation.append("PropertyName", item?.Property?.label);
                    validation.append("PropertyNo", item?.Property?.value);
                    validation.append("UnitNo", item?.Unit?.label);
                    validation.append("GroupId", leaseData?.groupId);
                    validation.append("UnitRefNo", item?.unitRefNo);

                    const validRes = await apiService.getApiParamater(
                        "GET_UNITNO_DATA",
                        `?${validation?.toString()}`
                    );

                    if (validRes?.data?.result?.data?.Count > 0) {
                        toast.warning(
                            `Selected Unit ${item?.Unit?.label} Already Existed in lease Aggrement, in Given ${transData?.periodFrom} to ${transData?.periodTo}`
                        );
                        return null;
                    }

                    return {
                        recordId: leaseData?.recordId,
                        leaseNo: leaseData?.leaseNo,
                        groupId: leaseData?.groupId,
                        proposalNo: "0",
                        propertyNo: item?.Property?.value,
                        propertyName: item?.Property?.label,
                        unitNo: item?.Unit?.label,
                        unitRefNo: item?.unitRefNo,
                        unitClass: item?.unitClass,
                        totalArea: parseFloat(item?.totalArea),
                        rentPerAnnum: parseFloat(item?.rentPerAnum),
                        periodRent: parseFloat(item?.rentForPeriod),
                        discountPercent: parseFloat(item?.discountPerc) || 0,
                        discount: parseFloat(item?.FreeRent) || 0,
                        rent: parseFloat(item?.rentForPeriod),
                        vat: parseFloat(item?.vat),
                        total: parseFloat(item?.total),
                        taxCode: parseInt(item?.vatRecord),
                        taxPercent: parseFloat(item?.taxRate),
                        landlord: item?.Landloard,
                        municipalityNo: item?.munAcNo,
                        createdBy: userName,
                        createdOn: currentDatetimeUTC,
                        isAdded: true,
                        isUpdated: false,
                        rentNL: false,
                    };
                })
            );

            const formattedRows = unitDetailsList.filter(Boolean);
            if (formattedRows.length === 0) {
                toast.warning(`Please Select Unit to Update Lease Aggrement`);
                setloader(false);
                return;
            }
            const additionalChargesList = additionalCharges.map((item, index) => ({
                recordId: leaseData?.recordId,
                leaseNo: leaseData?.leaseNo,
                groupId: leaseData?.groupId,
                description: item?.Description,
                mId: item?.RecordId,
                drAcCode: item?.DrAcCode || transData?.CustomerAccount?.label,
                drAcName: item?.DrAcName || transData?.CustomerName?.label,
                crAcCode: item?.CrAcCode || item?.AccountCode || "0",
                crAcName: item?.CrAcName || item?.CreditAccount || "0",
                taxCode: item?.TaxCode,
                taxInclusive: item?.TaxInclusive,
                amount: item?.Amount,
                vat: item?.VAT,
                total: item?.Total,
                remarks: item?.Remarks,
                posting: item?.Posting,
                isDeposit: item?.IsDeposit,
                status: "0",
                psdId: 0,
                propertyNo: dataList[0]?.Property?.value,
                propertyName: dataList[0]?.Property?.label,
                unitNo: dataList[0]?.Unit?.label,
                unitRefNo: dataList[0]?.unitRefNo,
                tenantNo: transData?.CustomerAccount?.label,
                tenantName: transData?.CustomerName?.label,
                category: "",
                receiptNo: "0",
                receiptDate: currentDatetimeUTC,
                voucherNo: "0",
                voucherDate: currentDatetimeUTC,
                financialYear: "FY 2025",
                exp1: "0",
                exp2: "0",
                exp3: "0",
                exp4: "0",
                exp5: "0",
                modifiedBy: userName,
                modifiedOn: currentDatetimeUTC,
                createdBy: userName,
                createdOn: currentDatetimeUTC,
                vatDescription: item?.VATDescription || "0",
                isChecked: true,
            }));
            const leaseAgreementMaster = {
                recordId: leaseData?.recordId,
                leaseNo: leaseData?.leaseNo,
                group_Id: leaseData?.groupId,
                leaseDate: transData?.periodFrom,
                leaseExpiry: transData?.periodTo,
                status: "0",
                tenantNo: transData?.CustomerAccount?.label,
                tenantName: transData?.CustomerName?.label,
                tenantTradeName: "",
                tenantBrand: "",
                totalArea: 0,
                totalAmount: 0,
                totalAmountByUser: 0,
                leaseTerm: leaseTerm?.toString(),
                leaseTermInMonths: parseInt(transData?.leaseTerm / 30),
                paymentTerm: "",
                paymentTermNoOfChqs: transData?.noInstallment,
                discountPercent: 0,
                discount: 0,
                taxCode: 0,
                taxInclusive: false,
                vatPercent: 0,
                stPercent: 0,
                st: 0,
                vat: 0,
                rent: 0,
                total: 0,
                modifiedBy: userName,
                modifiedOn: currentDatetimeUTC,
                createdBy: userName,
                createdOn: currentDatetimeUTC,
                transactionDate: transData?.transectionDate,
                rentFreeDays: 0,
                rentFreeAmount: 0,
                remarks: transData?.remarks2,
                arabicRemarks: transData?.arabicRemarks || "",
                leasingAgent: transData?.leaseAgent?.label || "",
                brokerName: transData?.Broker?.label || "",
                outletName: "",
            };
            const body = {
                leaseMain: {
                    leaseAgreementMaster: leaseAgreementMaster,
                    unitDetailsList: formattedRows,
                    additionalChargesList: additionalChargesList,
                    custPri_ContactNo: transData?.CustomerAccount?.value?.ContactNo?.toString() || "",
                    custPri_Email: transData?.CustomerAccount?.value?.Email || "",
                    custPri_PassportID: transData?.CustomerAccount?.value?.IDNo?.toString() || "",
                    custPri_Nationality: transData?.CustomerAccount?.value?.Nationality?.toString() || "",
                    custPri_VatRegNo: transData?.CustomerAccount?.value?.VATRegNo?.toString() || "",
                    custJoint_CustNo: transData?.JointCustomerAccount?.label || "",
                    custJoint_CustName: transData?.JointCustomerName?.label || "",
                    custJoint_ContactNo: transData?.JointCustomerAccount?.value?.ContactNo?.toString() || "",
                    custJoint_Email: transData?.JointCustomerAccount?.value?.Email || "",
                    custJoint_PassportID: transData?.JointCustomerAccount?.value?.IDNo?.toString() || "",
                    custJoint_Nationality: transData?.JointCustomerAccount?.value?.Nationality?.toString() || "",
                    custJoint_VatRegNo: transData?.JointCustomerAccount?.value?.VATRegNo?.toString() || "",
                },
            };
            debugger
            const postRes = await apiService.post("RENEW_LEASE_AGRE", body);
            debugger
            if (postRes?.data?.statusCode === 201) {
                // const token = localStorage.getItem("Token");
                // const DB = localStorage.getItem("DataBase")
                // if (!token) {
                //     alert("Auth token is missing! Unable to proceed.");
                //     return;
                // }
                // const popupWidth = 1000;
                // const popupHeight = 600;
                // const popupLeft = (window.screen.width - popupWidth) / 2;
                // const popupTop = (window.screen.height - popupHeight) / 2;
                // const popup = window.open(
                //     "",
                //     "ReportPopup",
                //     `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
                // );

                // if (popup) {
                //     const form = document.createElement("form");
                //     form.method = "POST";
                //     form.action =
                //         "https://procreports.pro360dev.freemyip.com/RDLReport/WebForm/ProcurementReports.aspx";
                //     form.target = "ReportPopup";

                //     const inputs = [
                //         { name: "authToken", value: token },
                //         { name: "_db", value: "PMK4000" },
                //         { name: "reportName", value: "LSESTMT" },
                //         { name: "voucherNo", value: postRes?.data?.result?.leaseNo },
                //     ];

                //     inputs.forEach(({ name, value }) => {
                //         const input = document.createElement("input");
                //         input.type = "hidden";
                //         input.name = name;
                //         input.value = value;
                //         form.appendChild(input);
                //     });

                //     document.body.appendChild(form);
                //     form.submit();
                //     document.body.removeChild(form);
                // }
                toast.success(`${postRes?.data?.result?.leaseNo} Renewed successfully`);
                setloader(false);
                navigate("/Property/Management/LeaseAgreement");
            } else {
            }
            ;
            setloader(false);
        } catch (error) {
            setloader(false);

            console.error("Error Save Data", error);
        }
    };

    const handleCheckboxChange = async (index, field, value) => {
        const updated = [...additionalCharges];
        updated[index][field] = value;
        let data = updated[index]
        // If it's the select checkbox, also manage isSelected
        if (field === "isSelected") {
            updated[index].isSelected = value;
        }
        if (field === "Rate") {
            let qty = parseFloat(data?.Qty) || 0
            let vatdes = data?.VATDescription
            let amount = (parseFloat(value) * qty)
            if (vatdes) {
                const taxParam = new URLSearchParams();
                taxParam.append("Action", "GetTaxRecordIdByTaxName");
                taxParam.append("TaxDescription", vatdes);
                const taxrecord = await apiService.getApiParamater("GET_UNITNO_DATA", `?${taxParam.toString()}`);
                const result = taxrecord?.data?.result?.data;
                let VATRate = result.Rate || 0; // Save VAT % for future calc
                const vat = (parseFloat(amount || 0) * VATRate) / 100;
                let VAT = vat.toFixed(3);
                let Total = (parseFloat(amount || 0) + vat).toFixed(3);
                updated[index].Rate = value;
                updated[index].VATRate = VATRate;
                updated[index].VAT = VAT;
                updated[index].Amount = amount;
                updated[index].Total = Total;
            } else {
                const vat = (parseFloat(amount || 0) * 0) / 100;
                let VAT = vat.toFixed(3);
                let Total = (parseFloat(amount || 0) + vat).toFixed(3);
                updated[index].Rate = value?.toFixed(3);
                updated[index].Amount = amount;
                updated[index].Total = Total;
            }
        }
        if (field === "Qty") {
            let rate = parseFloat(data?.Rate) || 0
            let vatdes = data?.VATDescription
            let amount = (parseFloat(value) * rate)
            if (vatdes) {
                const taxParam = new URLSearchParams();
                taxParam.append("Action", "GetTaxRecordIdByTaxName");
                taxParam.append("TaxDescription", vatdes);
                const taxrecord = await apiService.getApiParamater("GET_UNITNO_DATA", `?${taxParam.toString()}`);
                const result = taxrecord?.data?.result?.data;
                let VATRate = result.Rate || 0; // Save VAT % for future calc
                const vat = (parseFloat(amount || 0) * VATRate) / 100;
                let VAT = vat.toFixed(3);
                let Total = (parseFloat(amount || 0) + vat).toFixed(3);
                updated[index].Qty = value;
                updated[index].VATRate = VATRate;
                updated[index].VAT = VAT;
                updated[index].Amount = amount;
                updated[index].Total = Total;
            } else {
                const vat = (parseFloat(amount || 0) * 0) / 100;
                let VAT = vat.toFixed(3);
                let Total = (parseFloat(amount || 0) + vat).toFixed(3);
                updated[index].Qty = value;
                updated[index].Amount = amount;
                updated[index].Total = Total;
            }
        }
        setAdditionalCharges(updated);
    }
    const handleVatChange = async (index, selectedValue) => {
        const selectedOption = taxCodeList.find(tc => tc.value === selectedValue);
        if (!selectedOption) return;

        const taxParam = new URLSearchParams();
        taxParam.append("Action", "GetTaxRecordIdByTaxName");
        taxParam.append("TaxDescription", selectedOption.text);

        try {
            const taxrecord = await apiService.getApiParamater("GET_UNITNO_DATA", `?${taxParam.toString()}`);
            const result = taxrecord?.data?.result?.data;

            if (result) {
                setAdditionalCharges(prev => {
                    const updated = [...prev];
                    const row = { ...updated[index] };

                    row.TaxCodeValue = selectedValue;
                    row.VATDescription = selectedOption.text;
                    row.VATRate = result.Rate; // Save VAT % for future calc

                    const vat = (parseFloat(row.Amount || 0) * result.Rate) / 100;
                    row.VAT = vat.toFixed(3);
                    row.Total = (parseFloat(row.Amount || 0) + vat).toFixed(3);

                    updated[index] = row;
                    return updated;
                });
            }
        } catch (error) {
            console.error("Failed to fetch VAT data:", error);
        }
    }
    const preventNegativeSign = (e) => {
        if (e.key === "-" || e.key === "+") {
            e.preventDefault();
        }
    };
    return (
        <div className="p-5">
            <div className="row my-3">
                <div className="col-lg-8 nav nav-pills overslid d-flex gap-4">
                    <div
                        className={`dashitems sidebar-text center ${activeTab === 0 ? "sideActive" : ""
                            }`}
                        onClick={() => handleTabClick(0)}
                    >
                        Transaction and Tenant
                    </div>
                    <div
                        className={`dashitems sidebar-text center  ${activeTab === 1 ? "sideActive" : ""
                            }`}
                        onClick={() => handleTabClick(1)}
                    >
                        Unit Details
                    </div>
                    <div
                        className={`dashitems sidebar-text center  ${activeTab === 2 ? "sideActive" : ""
                            }`}
                        onClick={() => handleTabClick(2)}
                    >
                        Additional Charges
                    </div>
                </div>
                <div className="col-lg-4 d-flex gap-1">
                    {loading === true ? (
                        <div className="mainbtn flex-end gap-2 w-50">
                            <ClipLoader color="#ffffff" className="mt-1" size={25} />
                        </div>
                    ) : (
                        <div className="mainbtn flex-end gap-2 w-50" onClick={handleSave}>
                            <FaSave color="#fff" className="center mt-2 mx-2" />
                            <div className="center">Save</div>
                        </div>
                    )}
                    <div className="mainbtnRed flex-end gap-2 w-50"
                        onClick={handleclearform}
                    >
                        <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                        <div className="center">Reset</div>
                    </div>
                    <div className="mainbtnSecondary flex-end gap-2 w-50"
                        onClick={() => navigate("/Property/Management/LeaseAgreement")}
                    >
                        <FaChevronLeft color="#fff" className="center mt-2 mx-2" />
                        <div className="center">Back</div>
                    </div>
                </div>
            </div>
            {gridVisibility[0] && (
                <Transection loader={loader}
                    customerList={customerList}
                    leasingAgent={leasingAgent}
                    remarksList={remarksList}
                    unitData={unitData}
                    setTransData={setTransData}
                    transData={transData}
                    setLeaseTerm={setLeaseTerm} periodTo={periodTo} leaseTerm={leaseTerm}
                    setPeriodFrom={setPeriodFrom} setPeriodTo={setPeriodTo} periodFrom={periodFrom}
                />
            )}
            {gridVisibility[1] && (
                <UnitDetailsEdt rentPerAnum={rentPerAnum} calculatedTotal={calculatedTotal} totalRent={totalRent} totalVat={totalVat} totalDiscount={totalDiscount}
                    dataList={dataList} selectedIndex={selectedIndex} setSelectedIndex={setSelectedIndex} formData={formData} setFormData={setFormData}
                    taxCodeList={taxCodeList} propertylist={propertylist} setAdditionalCharges={setAdditionalCharges} setUntData={setUntData}
                    handleclearform={handleclearform} setDataList={setDataList}
                />
            )}
            {gridVisibility[2] && (
                <div
                    className="table-container my-3"
                    style={{ overflowX: "auto", height: "700px" }}
                >
                    <table>
                        <thead className="dynoTable">
                            <tr>
                                <th>Select</th>
                                <th>Description</th>
                                <th>Rate</th>
                                <th>Qty</th>
                                <th>Amount</th>
                                <th>Tax Code</th>
                                <th>Vat</th>
                                <th>Total</th>
                                <th>Posting</th>
                                <th>Remarks</th>
                                <th>From Rent</th>
                            </tr>
                        </thead>
                        <tbody>
                            {additionalCharges?.map((row, index) => (
                                <tr key={row.RecordId}>
                                    {/* Select */}
                                    <td className="m-0 p-0 text-center">
                                        <div className="center mt-1">
                                            <input
                                                type="checkbox" className="center"
                                                checked={row.isSelected || false}
                                                onChange={(e) =>
                                                    handleCheckboxChange(index, "isSelected", e.target.checked)
                                                }
                                                style={{ width: "20px", height: "20px" }}
                                            />
                                        </div>
                                    </td>

                                    {/* Description */}
                                    <td className="m-0 p-0">
                                        <input
                                            className="p-1"
                                            value={row.Description}
                                            disabled
                                            style={{ width: "400px" }}
                                        />
                                    </td>

                                    {/* Rate */}
                                    <td className="m-0 p-0">
                                        <input
                                            className="p-1"
                                            type="number" onKeyDown={preventNegativeSign}
                                            value={row.Rate || ""}
                                            onChange={(e) =>
                                                handleCheckboxChange(index, "Rate", e.target.value)
                                            }
                                            style={{ width: "100px" }}
                                        />
                                    </td>

                                    {/* Qty */}
                                    <td className="m-0 p-0">
                                        <input
                                            className="p-1" onKeyDown={preventNegativeSign}
                                            type="number"
                                            value={row.Qty || ""}
                                            onChange={(e) =>
                                                handleCheckboxChange(index, "Qty", e.target.value)
                                            }
                                            style={{ width: "100px" }}
                                        />
                                    </td>

                                    {/* Amount */}
                                    <td className="m-0 p-0">
                                        <input
                                            className="p-1"
                                            type="text"
                                            value={row.Amount?.toFixed(3) || ""}
                                            disabled
                                            style={{ width: "120px" }}
                                        />
                                    </td>

                                    {/* Tax Code */}
                                    <td className="m-0 p-0">
                                        <select
                                            className="p-1"
                                            value={row.TaxCodeValue || row?.VATDescription || ""}
                                            onChange={(e) => handleVatChange(index, e.target.value)}
                                            style={{ width: "300px" }}
                                        >
                                            <option value="">Select Tax Code</option>
                                            {taxCodeList.map((tax) => (
                                                <option key={tax.value} value={tax.value}>
                                                    {tax.text}
                                                </option>
                                            ))}
                                        </select>
                                    </td>

                                    {/* Vat */}
                                    < td className="m-0 p-0" >
                                        <input
                                            className="p-1"
                                            value={row.VAT?.toFixed(3) || 0}
                                            disabled
                                            style={{ width: "100px" }}
                                        />
                                    </td>

                                    {/* Total */}
                                    <td className="m-0 p-0">
                                        <input
                                            className="p-1"
                                            value={row.Total?.toFixed(3) || "0.00"}
                                            disabled
                                            style={{ width: "120px" }}
                                        />
                                    </td>

                                    {/* Posting */}
                                    <td className="m-0 p-0 text-center">
                                        <input
                                            type="checkbox"
                                            checked={row.Posting || false}
                                            onChange={(e) =>
                                                handleCheckboxChange(index, "Posting", e.target.checked)
                                            }
                                            style={{ width: "20px", height: "20px" }}
                                        />
                                    </td>

                                    {/* Remarks */}
                                    <td className="m-0 p-0">
                                        <input
                                            className="p-1"
                                            value={row.Remarks || ""}
                                            onChange={(e) =>
                                                handleCheckboxChange(index, "Remarks", e.target.value)
                                            }
                                            style={{ width: "400px" }}
                                        />
                                    </td>

                                    {/* From Rent */}
                                    <td className="m-0 p-0 text-center">
                                        <input
                                            type="checkbox" className="w-100"
                                            checked={row.IsDeposit || false}
                                            onChange={(e) =>
                                                handleCheckboxChange(index, "IsDeposit", e.target.checked)
                                            }
                                            style={{ width: "20px", height: "20px" }}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div >
            )}
        </div>
    );
};
export default LeaseAgreementRenew;
